import { render, staticRenderFns } from "./text_right.vue?vue&type=template&id=031e8b58&scoped=true&"
import script from "./text_right.vue?vue&type=script&lang=js&"
export * from "./text_right.vue?vue&type=script&lang=js&"
import style0 from "./text_right.vue?vue&type=style&index=0&id=031e8b58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031e8b58",
  null
  
)

component.options.__file = "text_right.vue"
export default component.exports